import styled, { CSSObject } from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import {
  Button,
  Typography,
  Link,
  generatePadding,
  mediaQuery
} from '@lacedltd/laced-components'

export const MobileNav = styled.div({
  background: tokens.color.yeezy.p,
  width: '100%',
  height: '100%',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column'
})

export const ContentSection = styled.div({
  padding: generatePadding(0, 0, 'spacing.9', 'spacing.10'),

  'a:last-of-type': { borderBottom: 'none' },

  [mediaQuery.l.min]: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: tokens.spacing[8]
  }
})

export const BrowseAllLink = styled.div({
  [mediaQuery.l.min]: {
    display: 'none',
    gridColumn: '1 / -1'
  }
})

export const SectionTitle = styled(Typography.Text)({
  padding: generatePadding('spacing.7', 'spacing.6', 'spacing.5', 0),
  borderBottom: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[100]}`,
  borderRadius: tokens.borderRadius.none,
  marginBottom: 0
})

export const textStyle: CSSObject = {
  width: '100%',
  padding: generatePadding('spacing.5', 'spacing.6', 'spacing.5', 0),
  display: 'flex',
  justifyContent: 'space-between',
  borderBottom: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[100]}`,
  borderRadius: tokens.borderRadius.none,

  '&:hover': {
    background: 'transparent',

    [mediaQuery.l.min]: {
      backgroundColor: tokens.color.superstar.p,
      transition: 'background-color 0.15s ease'
    }
  },

  span: { marginBottom: 0 }
}

export const MobileNavButton = styled(Button)(textStyle, {
  textDecoration: 'none',
  textTransform: 'none'
})

export const MobileNavLink = styled(Link)(textStyle)

export const AccountSection = styled.section({
  background: tokens.color.superstar.p,
  padding: generatePadding('spacing.8', 0),
  color: tokens.color.airJordan.p,

  [mediaQuery.l.min]: {
    marginTop: 'auto',

    a: { display: 'none' },
    h4: { display: 'none' }
  }
})

export const Links = styled.div<{ isLoggedIn?: boolean }>(
  {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    width: '100vw',
    padding: generatePadding(0, 'spacing.6', 0, 'spacing.10'),
    gap: tokens.spacing[8],

    [mediaQuery.l.min]: {
      alignItems: 'center',
      padding: generatePadding(0, 'spacing.10')
    },

    a: {
      width: '100%'
    }
  },
  ({ isLoggedIn }) =>
    // this is last link which is the signout
    isLoggedIn && {
      'a:last-of-type': {
        paddingTop: tokens.spacing[6],
        borderTop: `${tokens.borderWidth.xs} solid ${tokens.color.airJordan[300]}`
      }
    }
)
